import { Avatar as MuiAvatar, type AvatarProps as MuiAvatarProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { AVATAR_SIZES, type AvatarSize } from './avatarSizes';

const ROOT_ELEMENT = 'span';

type ImageProps
  = | { src?: undefined; srcSet?: undefined; alt?: string }
    | { src?: string; srcSet?: string; alt: string };

type Props = WithoutStyleOverrides<
  Omit<MuiAvatarProps<typeof ROOT_ELEMENT>, 'color' | 'slots' | 'slotProps' | 'src' | 'srcSet' | 'alt'>
> & ImageProps & {
  size?: AvatarSize;
};

export function Avatar(props: Props) {
  const { size = 'medium', ...avatarProps } = props;

  return <MuiAvatar {...avatarProps} component={ROOT_ELEMENT} sx={AVATAR_SIZES[size]} />;
}

export type { Props as AvatarProps };
